module.exports = __webpack_public_path__ + "img/Play-time-compressor.65d66243.jpg";